import { Box, IconButton, TextField } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import theme from "../../configs/theme";

export default function CreateNoteUI({ text, setText, handleSend }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        height: "10%",
      }}
    >
      <TextField
        fullWidth
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && text.trim() !== "") {
            e.preventDefault();
            handleSend();
            setText("");
          }
        }}
        variant="outlined"
        size="small"
        sx={{
          backgroundColor: theme.colors.secondary,
          borderRadius: 2,

          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            color: "white",
            py: 0.2,
          },
        }}
        placeholder="Escribí una nota..."
      />
      <IconButton onClick={handleSend}>
        <SendIcon />
      </IconButton>
    </Box>
  );
}
